























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BlockAlignmentDto, ImageTileGroupBlockDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import CmsImageLink from '@/views/cms/snippet/CmsImageLink.vue';

@Component({
  components: {CmsImageLink, CmsLink},
})
export default class ImageTileGroupBlock extends Vue {
  @Prop({required: true})
  public readonly model!: ImageTileGroupBlockDto;

  get backgroundColor(): string {
    return this.model.backgroundColor || 'transparent';
  }

  get flexBasis(): string {
    if (this.model.tilesPerLine && this.model.tilesPerLine > 0) {
      return `${100 / this.model.tilesPerLine}%`;
    }
    return '25%';
  }

  get showLinkButton() {
    return this.model.link && this.model.link.target;
  }

  get titleAlignment(): string {
    switch (this.model.alignCaption) {
      case BlockAlignmentDto.CENTER:
        return 'center';
      case BlockAlignmentDto.RIGHT:
        return 'flex-end';
      default:
        return 'flex-start';
    }
  }
}
